import { createSelector } from 'reselect';
/**
 * Direct selector to the formBuilder state domain
 */
const selectFormBuilderDomain = () => (state) => state.get('formBuilder');

const selectFieldDataDomain = (path) => (state) => state.getIn(['formBuilder', 'form', ...path]);

const selectFieldsDomain = () => (state) => state.getIn(['formBuilder', 'form', 'fields']);

const selectSalesForceDataDomain = () => (state) => state.getIn(['formBuilder', 'meta', 'sfFieldData']);

const selectFormIdDomain = (state) => state.getIn(['formBuilder', 'form', 'id']);

const selectFormGroupingDomain = (state) => state.getIn(['formBuilder', 'form', 'groupingId']);

const selectDegreeOffering = () => (state) => state.getIn(['formBuilder', 'form', 'degreeOffering']);

const selectProgramOfStudy = () => (state) => state.getIn(['formBuilder', 'form', 'programOfStudy']);

const selectGDPRSetting = () => (state) => state.getIn(['formBuilder', 'form', 'syntheticContentEntities', 'gdprSetting']);

const selectCredentialType = () => (state) => state.getIn(['formBuilder', 'meta', 'credentialType']);

/**
 * Other specific selectors
 */

/**
 * Default selector used by FormBuilder
 */

const makeSelectFormBuilder = () => createSelector(
  selectFormBuilderDomain(),
  (substate) => substate.toJS()
);

const makeSelectFieldData = (keyPath) => createSelector(
  selectFieldDataDomain(keyPath),
  (substate) => substate.toJS()
);

const makeSelectFields = () => createSelector(
  selectFieldsDomain(),
  (substate) => substate.toJS()
);

const makeSelectSalesForceData = (valueName) => createSelector(
  selectSalesForceDataDomain(),
  (substate) => substate.get(valueName) ? substate.get(valueName).toJS() : {}
);

const makeSelectFormIdentifiers = () => createSelector(
  [
    selectFormIdDomain,
    selectFormGroupingDomain,
  ],
  (id, groupingId) => ({
    id,
    groupingId,
  })

);

export default makeSelectFormBuilder;
export {
  selectProgramOfStudy,
  selectDegreeOffering,
  selectFormBuilderDomain,
  selectGDPRSetting,
  selectCredentialType,
  makeSelectFieldData,
  makeSelectFields,
  makeSelectSalesForceData,
  makeSelectFormIdentifiers,
};
